'use client';

import type { GridProps as MuiGridProps } from '@mui/material';
import { Grid as MuiGrid } from '@mui/material';

export type GridProps = MuiGridProps;

/** The Mui responsive layout grid adapts to screen size and orientation, ensuring consistency across layouts. https://mui.com/material-ui/react-grid/ */
export const Grid = MuiGrid;
